import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./MainLayout";
import BankingPartners from "../pages/CreditManagerPortal/BankingPartners";
import PartnerDetails from "../pages/AdminPortal/PartnerDetails";
import Customer from "../pages/CreditManagerPortal/Customer";
import LoanApplicationView from "../pages/CreditManagerPortal/LoanApplicationView";
import Dashboard from "../pages/CreditManagerPortal/Dashboard";
import CommunicationCenter from "../pages/CreditManagerPortal/CommunicationCenter";
import UniversalAnalysers from "../pages/AdminPortal/UniversalAnalysers";
import Attendance from "../pages/StaffPortal/Attendance";

const CreditManagerLayout = () => {
  return (
    <MainLayout>
      {" "}
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="customers" element={<Customer />} />
        <Route path="loan-applications/:id" element={<LoanApplicationView />} />
        <Route path="loan-applications/approval/:id" element={<LoanApplicationView />} />
        <Route path="banking-partner" element={<BankingPartners />} />
        <Route path="banking-partner/:id" element={<PartnerDetails />} />
        <Route path="communication" element={<CommunicationCenter />} />
        <Route path="universal-analysers/:id" element={<UniversalAnalysers />} />
        <Route path="attendance" element={<Attendance />} />
        <Route
          path="*"
          element={
            <div className="flex items-center justify-center min-h-screen bg-[#131313] text-white p-4">
              <div className="text-center">
                <h1 className="text-5xl font-bold text-[#FFCA20] mb-4">404</h1>
                <h2 className="text-2xl mb-4">Page Not Found</h2>
                <p className="text-gray-400 mb-6">
                  The page you are looking for doesn't exist or you are not
                  authorised.
                </p>
                <a
                  href="/credit-manager/dashboard"
                  className="bg-[#FFCA20] hover:bg-yellow-600 text-black font-medium py-2 px-6 rounded"
                >
                  Go to Dashboard
                </a>
              </div>
            </div>
          }
        />
      </Routes>
    </MainLayout>
  );
};

export default CreditManagerLayout;
